module.exports = __webpack_public_path__ + "img/IR.f6903c10.svg";